var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClipGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22.222,
    viewBox: "0 0 20 22.222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_job_2",
    "data-name": "Vector job 2",
    d: "M17.778,2.222H13.133a3.32,3.32,0,0,0-6.267,0H2.222A2.229,2.229,0,0,0,0,4.444V20a2.229,2.229,0,0,0,2.222,2.222H17.778A2.229,2.229,0,0,0,20,20V4.444A2.229,2.229,0,0,0,17.778,2.222ZM10,2.222A1.111,1.111,0,1,1,8.889,3.333,1.114,1.114,0,0,1,10,2.222ZM7.778,17.778,3.333,13.333,4.9,11.767l2.878,2.867L15.1,7.311l1.567,1.578Z",
    fill: "rgba(26,26,26,0.5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipGray);
export default __webpack_public_path__ + "static/media/clipGray.6577aea47cc54509c148a32e21de6177.svg";
export { ForwardRef as ReactComponent };